import { DATE_FORMAT } from '@/main.config'

export const formatDate = {
  methods: {
    getMomentDate(date) {
      return this.moment.utc(date, DATE_FORMAT.serverFull).local()
    },
    getFormattedDate(date, isShort = false) {
      const momentDate = this.getMomentDate(date)
      if (!momentDate) {
        return null
      }
      return momentDate.format(
        isShort
          ? DATE_FORMAT[`${this.$store.getters.LOCALE}Short`]
          : DATE_FORMAT[`${this.$store.getters.LOCALE}`]
      )
    },
    getFormattedTime(date) {
      const momentDate = this.getMomentDate(date)
      if (!momentDate) {
        return null
      }
      return momentDate.format(DATE_FORMAT.timeHM)
    },
    addSecondsToDateString(inputString, secondsToAdd) {
      const parsedDate = new Date(inputString.replace(/(\d+).(\d+).(\d+)/, '$2 $1 $3'))
      parsedDate.setSeconds(parsedDate.getSeconds() + secondsToAdd)
      const formattedDate = `${parsedDate
        .getDate()
        .toString()
        .padStart(2, '0')}.${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}.${(
        parsedDate.getFullYear() - 2000
      )
        .toString()
        .padStart(2, '0')} ${parsedDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${parsedDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${parsedDate
        .getSeconds()
        .toString()
        .padStart(2, '0')}`
      return formattedDate
    }
  }
}
